export const TRIGGER_AFTER = 'after'; // eslint-disable-line import/prefer-default-export
